"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineCompletionStatus = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineTotalByType_1 = require("./getOrderLineTotalByType");
const getOrderLineCompletionStatus = (item) => {
    if (!item.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return null;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            if (!config?.where_when_who?.date)
                return false;
            if (!config?.product?.id)
                return false;
            return true;
        }
        case "HOTEL": {
            const config = latest_version.config;
            if (!config?.where_when_who.hotel?.id)
                return false;
            if (!config?.supplier?.id || config?.supplier?.id === "")
                return false;
            const price = (0, getOrderLineTotalByType_1.getOrderLineTotalByType)(config, "HOTEL");
            if (price === 0)
                return false;
            return true;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            if (!config?.vehicle?.vehicle?.id)
                return false;
            if (!config?.transfer_legs?.inbound)
                return true;
            if (!config?.supplier?.id || config?.supplier?.id === "")
                return false;
            return true;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            if (!config?.product?.rate)
                return false;
            if (!config?.supplier?.id || config?.supplier?.id === "")
                return false;
            return true;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            if (!config?.supplier?.id || config?.supplier?.id === "")
                return false;
            return true;
        }
    }
    return null;
};
exports.getOrderLineCompletionStatus = getOrderLineCompletionStatus;
